class Newsletter {

    constructor() {
        this.receipt = document.querySelector('.footer__newsletter__receip')
    }

    init() {

        document
            .getElementById('newsletter-form')
            .addEventListener("submit", (evt) => {
                evt.preventDefault()
                this.subscribe()
            }, true);
    }

    subscribe() {
        const emailInput = document.querySelector('.footer__newsletter__form__input')
        const email = document
            .querySelector('.footer__newsletter__form__input')
            .value

        if (email === '') {
            return
        }

        fetch('/api/newsletter.php', {
                method: 'POST',
                body: JSON.stringify({email: email})
            })
            .then(res => res.json())
            .then(res => {

                const lang = document.body.dataset.lang

                if (res.success === 'ok') {
                    this.receipt.innerHTML = (lang === 'fr')
                        ? 'Merci !'
                        : 'Thank You !'
                    emailInput.innerHTML = ''

                } else {
                    let message = lang === 'fr'
                        ? "Une erreur est survenue"
                        : "An error has occured"
                    if (res.success.includes('400')) {
                        message = lang === 'fr'
                            ? "Vous êtes déjà inscrit(e)"
                            : "You already subscribed"
                    }
                    this.receipt.innerHTML = message
                }
                setTimeout(() => {
                    this.receipt.innerHTML = ''
                }, 3000)

            })
            .catch(err => console.log('err mc', err));
    }

}

export default Newsletter


// WEBPACK FOOTER //
// ./src/js/components/Newsletter.js